import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Usuario,RegistroService } from 'src/app/services/registro.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [ './login.component.css' ]
})
export class LoginComponent implements OnInit {

  usuario: Usuario={
    email:'',
    nombre:'',
    password:'',
    cargo:0,
    numemp:0,   
  };

  recordarUsuario=false;
  anio:any;
  fecha:any;
  // inicioSesion:any;

  inicioSesion:any;
  terminoSesion:any;


  constructor( private router:Router,private registro:RegistroService ) { }

  ngOnInit(): void {
    let hoy = new Date();
    this.fecha=hoy.toLocaleDateString()
    this.anio=hoy.getFullYear();
    
    if(localStorage.getItem('token')){
      localStorage.clear();
     }

     if(localStorage.getItem('email')){

      this.usuario.email=localStorage.getItem('email')!;
      this.recordarUsuario=true;
    }

    if(localStorage.getItem('token')){
     localStorage.removeItem('token');
     localStorage.removeItem('datos');
     localStorage.removeItem('cargo');
     localStorage.removeItem('plantel');
     localStorage.removeItem('Id');
    }

    // this.recargarlogin();

  }
 
  buscaUsuario(form:NgForm, email:any,password:any){

    if(form.invalid){
      console.log('Formulario Invalido');
    Swal.fire({
  title: '<i  style="color:#d64f4f;"></i> Error',
  html: '<p style="text-align:center; color:#333; margin:10px 0;">¡Complete todos los campos!</p>',
  icon: 'error',
  iconColor: '#d64f4f',
  confirmButtonText: 'Aceptar',
  confirmButtonColor: '#720f3c',
  background: '#ffffff',
  customClass: {
    popup: 'animated-popup'
  },
  backdrop: 'rgba(0,0,0,0.3)'
});

      return;
}else{    
    this.registro.loginUsuario(email,password).subscribe(
      res=>{     
     
        localStorage.setItem('datos',JSON.stringify(res));
        let datos=JSON.parse(localStorage.getItem('datos')!);

        if(res=="NoEncontrado"){
          
     Swal.fire({
  title: '<i  style="color:#d64f4f;"></i> Error de autenticación!',
  html: '<p style="text-align:center; color:#333; margin:10px 0;">Verifique sus datos</p>',
  icon: 'error',
  iconColor: '#d64f4f',
  confirmButtonText: 'Aceptar',
  confirmButtonColor: '#720f3c',
  background: '#ffffff',
  customClass: {
    popup: 'animated-popup'
  },
  backdrop: 'rgba(0,0,0,0.3)'
});

        }else{

          localStorage.setItem('token',datos.token);
          localStorage.setItem('id_user',datos.id_user);
          localStorage.setItem('usuario',datos.usuario);
          localStorage.setItem('permiso',datos.permiso);
          localStorage.setItem('departamento_id',datos.departamento_id);
          localStorage.setItem('nombre_trabajador',datos.nombre_trabajador);
          localStorage.setItem('nombre',datos.nombre);

          var Hora=new Date().getHours();
          var Minuto=new Date().getMinutes();
          var Segundo=new Date().getSeconds();

          if(Hora<=9){
            var HoraString="0"+Hora.toString();
          }else{
          HoraString=Hora.toString();
        }

        if(Minuto<=9){
          var MinutoString="0"+Minuto.toString();
        }else{
        MinutoString=Minuto.toString();
      }


          if(Segundo<=9){
              var SegundoString="0"+Segundo.toString();
          }else{
            SegundoString=Segundo.toString();
          }

       
      
      
          this.inicioSesion=HoraString+":"+MinutoString+":"+SegundoString+""
          this.terminoSesion=(Hora+2)+":"+MinutoString+":"+SegundoString+""
          console.log(this.inicioSesion);

           localStorage.setItem('inicioSesion',this.inicioSesion);
           localStorage.setItem('finSesion',this.terminoSesion);
      
          this.mensajeSesion();

          this.router.navigateByUrl("/dashboard");
        
        }
       },  
         err=>console.log(err)
      );

  }

}


  login() {
    this.router.navigateByUrl('/');
  }

mensajeSesion() {
  Swal.fire({
    title: '<i  style="color:#d6c07f;"></i> Inicio de sesión',
    html: `
      <p style="text-align:left; color:#333; margin:10px 0;"><b>Hora de inicio:</b> ${this.inicioSesion}</p>
      <p style="text-align:left; color:#333; margin:10px 0;"><b>Su sesión expira:</b> ${this.terminoSesion}</p>
      <hr style="border:0; border-top:1px solid #f0c0d0; margin:15px 0;">
      <p style="text-align:left; color:#720f3c; font-size:0.95rem;">
        <b>Importante:</b> Una vez que finalice el tiempo de su sesión, se cerrará su acceso automáticamente y deberá iniciar sesión nuevamente.
      </p>
    `,
    icon: 'info',
    iconColor: '#d6c07f',
    confirmButtonText: 'Entendido',
    confirmButtonColor: '#8f124d',
    background: '#ffffff',
    allowOutsideClick: false,
    customClass: {
      popup: 'animated-popup'
    },
    backdrop: 'rgba(0,0,0,0.3)'
  });
}


  // recargarlogin(){
  //   setTimeout(() => {
  // //  this.router.navigateByUrl("/login")
  //  window.location.reload()
  //  console.log("ccc");
  //    }, 10000);
  // }

}